import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Drawer,
  InputBase,
  Menu,
  MenuItem,
  Modal,
  Radio,
  Select,
} from "@mui/material";
import {
  Dashboard as DashboardIcon,
  DashboardCustomize,
  ErrorOutline,
  KeyboardArrowDown,
  SettingsInputComponent,
  KeyboardArrowRight,
  Logout,
  Support,
  SupportAgent,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { Contact, Settings as SettingIcon, X } from "lucide-react";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { setTokensFromResponse } from "../../utils/authTokens";
import {
  ChartNoAxesColumnIncreasing,
  Mic,
  PhoneOutgoing,
  Shield,
  SlidersVertical,
} from "lucide-react";
import { Route as RouteIcon } from "lucide-react";
import ChangeOrgProfile from "../reusables/ChangeOrgProfile";
import ChangeUserProfile from "../reusables/ChangeUserProfile";
import Logo from "../reusables/Logo";
import TrialSidebarNote from "../reusables/TrialSidebarNote";
import { isTaAdmin } from "../../utils/adminAuth";

const Sidebar = ({ open, setOpen, orgs }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));

  // Check if current user has type "user" for the current organization
  const isUserType = () => {
    try {
      const organization = JSON.parse(localStorage.getItem("organization"));
      const currentUser = JSON.parse(localStorage.getItem("user"));
      
      if (!organization?.users?.L || !currentUser?.userId?.S) {
        return false; // Default to showing settings if we can't determine
      }

      const currentUserInOrg = organization.users.L.find(
        (item) => item?.M?.userId?.S === currentUser.userId.S
      );

      return currentUserInOrg?.M?.type?.S === "user";
    } catch (error) {
      // Log for production diagnostics when user type check fails
      console.error("Error checking user type:", error);
      return false; // Default to showing settings on error
    }
  };

  const userIsUserType = isUserType();

  const [err_msg, setErrorMsg] = useState(null);
  const [loader, setLoader] = useState(false);
  const changeOrganization = async (org_id) => {
    try {
      const { fetchAndSetOrganization } = await import("../../utils/organizationService");
      await fetchAndSetOrganization(org_id);
      window.location.reload();
    } catch (error) {
      // Log for production diagnostics when change organization fails
      console.error("Sidebar: change organization failed", error.response?.data || error.message || error);
      if (error.response && error.response.data) {
        setErrorMsg(error.response.data.message);
      }
      setLoader(false);
    }
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open_ = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const [showCreateNewOrganization, setShowCreateNewOrganization] =
    useState(false);

  const [successMsg, setSuccessMsg] = useState(null);
  const [user_, setUser_] = useState({
    organization_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    userId: JSON.parse(localStorage.getItem("user"))?.userId?.S || null,
    email: JSON.parse(localStorage.getItem("user"))?.email?.S || null,
    password: JSON.parse(localStorage.getItem("user"))?.password?.S || null,
    first_name: JSON.parse(localStorage.getItem("user"))?.fName?.S || null,
    last_name: JSON.parse(localStorage.getItem("user"))?.lName?.S || null,
    company_name:
      JSON.parse(localStorage.getItem("organization"))?.organization_name?.S ||
      "",
    agreed: false,
    registeredFromGoogle:
      JSON.parse(localStorage.getItem("user"))?.registeredFromGoogle?.BOOL ||
      false,
  });

  const addOrganization = async () => {
    setErrorMsg(null);
    if (user_.company_name.length >= 1) {
      setLoader(true);
      await axios
        .post(
          process.env.REACT_APP_BACKEND_URL + "user/add-created-user-to-org",
          {
            ...user_,
            userId: JSON.parse(localStorage.getItem("user"))?.userId?.S,
          }
        )
        .then((res) => {
          if (res.data.status === "success") {
            localStorage.setItem("user", JSON.stringify(res.data.user)); //store user data in local storage
            localStorage.setItem(
              "organization",
              JSON.stringify(res.data.organization)
            ); //stores organization datat in local storage
            setTokensFromResponse(res.data);
            setSuccessMsg(
              "Organization has been created, we would now redirect you to complete onboarding flow. "
            );
            navigate("/register?neworg=true");
            setLoader(false);
          } else {
            setErrorMsg(`${res.data.msg}`);
            setLoader(false);
          }
        })
        .catch((err) => {
          setLoader(false);
        });
    } else {
      setErrorMsg("Please enter company name for your organization");
    }
  };
  return (
    <Drawer open={open} onClose={() => setOpen(false)}>
      <div className="text-[16px] space-y-3 bg-white   flex-1 w-[100vw]">
        <div className="relative">
          <X
            onClick={() => {
              setOpen(false);
            }}
            style={{
              color: { lg: "black", xs: "black" },
              position: "absolute",
              top: "24px",
              left: 5,
            }}
          />
          <div className="text-[20px] px-6 py-4 font-normal flex justify-start mb-0">
            <Logo size="sm" />
          </div>
        </div>
        <Divider sx={{ mb: 2 }} />
        {location.pathname === "/dashboard" ||
        location.pathname.startsWith("/dashboard/call-details") ? (
          <div
            onClick={() => {
              navigate("/dashboard");
              setOpen(false);
            }}
            className="cursor-pointer flex items-center text-[#605BFF] font-semibold pl-6  bg-[rgba(96,91,255,0.1)]    py-2 px-3  "
          >
            {" "}
            <ChartNoAxesColumnIncreasing className="w-[20px] mr-2" /> Dashboard{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3  text-black   pl-6  "
            onClick={() => {
              setOpen(false);
              navigate("/dashboard");
            }}
          >
            {" "}
            <ChartNoAxesColumnIncreasing className="w-[20px] mr-2" /> Dashboard{" "}
          </div>
        )}

        {location.pathname.startsWith("/dashboard/dialer") ? (
          <div
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/dialer");
            }}
            className="cursor-pointer flex items-center text-[#605BFF]  font-semibold pl-6  bg-[rgba(96,91,255,0.1)] py-2 px-3"
          >
            {" "}
            <PhoneOutgoing className="w-[20px] mr-2" /> Dialer{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3   pl-6  "
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/dialer");
            }}
          >
            {" "}
            <PhoneOutgoing className="w-[20px] mr-2" /> Dialer{" "}
          </div>
        )}

        {location.pathname.startsWith("/dashboard/call-routings") ||
        location.pathname.startsWith("/dashboard/call-route") ||
        location.pathname.startsWith("/dashboard/create-route") ? (
          <div
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/call-routings");
            }}
            className="cursor-pointer flex items-center text-[#605BFF] font-semibold pl-6  bg-[rgba(96,91,255,0.1)] py-2 px-3"
          >
            {" "}
            <RouteIcon className="w-[20px] mr-2" /> Call Routing{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3  pl-6  "
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/call-routings");
            }}
          >
            {" "}
            <RouteIcon className="w-[20px] mr-2" /> Call Routing{" "}
          </div>
        )}

        {location.pathname.startsWith("/dashboard/channels") ? (
          <div
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/channels");
            }}
            className="cursor-pointer flex items-center text-[#605BFF] font-semibold pl-6  bg-[rgba(96,91,255,0.1)] py-2 px-3"
          >
            {" "}
            <SlidersVertical className="w-[20px] mr-2" /> Channels{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3  pl-6  "
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/channels");
            }}
          >
            {" "}
            <SlidersVertical className="w-[20px] mr-2" /> Channels{" "}
          </div>
        )}

        {location.pathname.startsWith("/dashboard/recordings") ? (
          <div
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/recordings");
            }}
            className=" cursor-pointer flex items-center text-[#605BFF] font-semibold pl-6  bg-[rgba(96,91,255,0.1)] py-2 px-3"
          >
            {" "}
            <Mic className="w-[20px] mr-2" /> Recordings{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3  pl-6  "
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/recordings");
            }}
          >
            {" "}
            <Mic className="w-[20px] mr-2" /> Recordings{" "}
          </div>
        )}

        {location.pathname.startsWith("/dashboard/contacts") ||
        location.pathname.startsWith("/dashboard/contact/") ? (
          <div
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/contacts");
            }}
            className="cursor-pointer flex items-center text-[#605BFF] font-semibold pl-6  bg-[rgba(96,91,255,0.1)] py-2 px-3"
          >
            {" "}
            <Contact className="w-[20px] mr-2" /> Contacts{" "}
          </div>
        ) : (
          <div
            className="cursor-pointer flex items-center py-2 px-3  pl-6  "
            onClick={() => {
              setOpen(false);
              navigate("/dashboard/contacts");
            }}
          >
            {" "}
            <Contact className="w-[20px] mr-2" /> Contacts{" "}
          </div>
        )}

        {!userIsUserType && (
          <>
            {location.pathname.startsWith("/dashboard/settings") ? (
              <div
                onClick={() => {
                  setOpen(false);
                  navigate("/dashboard/settings");
                }}
                className="cursor-pointer flex items-center text-[#605BFF] font-semibold pl-6  bg-[rgba(96,91,255,0.1)] py-2 px-3"
              >
                {" "}
                <SettingIcon
                  src="/icons/settings-active.png"
                  className="w-[20px] mr-2"
                />{" "}
                Settings{" "}
              </div>
            ) : (
              <div
                className="cursor-pointer flex items-center py-2 px-3  pl-6  "
                onClick={() => {
                  setOpen(false);
                  navigate("/dashboard/settings");
                }}
              >
                {" "}
                <SettingIcon
                  src="/icons/settings-inactive.png"
                  className="w-[20px] mr-2"
                />{" "}
                Settings{" "}
              </div>
            )}
          </>
        )}
        {isTaAdmin() && (
          <div
            className="cursor-pointer flex items-center py-2 px-3 pl-6"
            onClick={() => {
              setOpen(false);
              navigate("/admin");
            }}
          >
            <Shield className="w-[20px] mr-2" /> Admin
          </div>
        )}
      </div>

      {err_msg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2  font-semibold ">
          <ErrorOutline sx={{ fontSize: "" }} /> {err_msg}
        </div>
      )}

      {/* <div className=" flex justify-center  items-center py-2 px-3 font-semibold ">
        {" "}
        <div className="space-y-2">
          <div className="text-left w-[130px]">
            {" "}
            {
              JSON.parse(localStorage.getItem("organization"))?.organization_name
                .S
            }{" "}
          </div>

          <div className="w-[180px] mx-auto ">
            {loader ? (
              <CircularProgress size={"1.3rem"} sx={{ color: "blue" }} />
            ) : (
              <Select
                IconComponent={KeyboardArrowDown}
                fullWidth
                value={
                  user?.relatedOrgs.L.filter(
                    (e) =>
                      e?.M.org_id.S ===
                      JSON.parse(localStorage.getItem("organization")).orgId.S
                  )[0]?.M.org_id.S
                }
                onChange={(f) => {
                  changeOrganization(f.target.value);
                }}
                className="mb-2 bg-[#F7F7F8]"
                sx={{
                  fontSize: "13px",
                  padding: "2px 8px", // Adjust padding here
                  "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                  "& .MuiSelect-select": {
                    padding: "2px 8px", // Adjust padding for the text inside Select
                  },
                }}
              >
                {user?.relatedOrgs.L.map((item, index) => {
                  return (
                    <MenuItem key={index} value={item?.M.org_id.S}>{orgs?.find((e) => e.orgId.S === item?.M.org_id.S)?.organization_name.S}</MenuItem>
                  );
                })}
              </Select>
            )}
          </div>
          <div className="flex justify-center">
            <Button
              sx={{
                textTransform: "none",
                bgcolor: "#E6E6E6",
                color: "#244F62",
                py: "10px",
                px: "9px",
                borderRadius: "6px",
                fontSize: { lg: "14px", xs: "14px" },
                width: "40vw",
              }}
            >
              Support
            </Button>
          </div>

          <div className="flex justify-center">
            <Button
              variant="contained"
                color="primary"
                sx={{                py: "10px",
                px: "9px",
                borderRadius: "6px",
                fontSize: { lg: "14px", xs: "14px" },
                width: "40vw",
              }}
              onClick={() => {
                console.info("[Auth] Logging out: user chose Log out from sidebar.");
                localStorage.clear("user");
                localStorage.clear("organization");
                setOpen(false)
                navigate("/login");
              }}
            >
              Log Out
            </Button>
          </div>
        </div>
      </div> */}

      <div className="w-[100%]   absolute  bottom-1    rounded-lg">
        <div className=" ">
          <TrialSidebarNote
            canChoosePlan={!userIsUserType}
            className="px-3 mb-3"
          />
          <Divider sx={{ mb: 2 }} />

          <CreateOrganizationModal
        open={showCreateNewOrganization}
        onClose={() => setShowCreateNewOrganization(false)}
        user={user_}
        setUser_={setUser_}
        addOrganization={addOrganization}
        loader={loader} 
      />

          <div className="px-3 w-full mb-5">
            <ChangeOrgProfile
              changeOrganization={changeOrganization}
              setShowCreateNewOrganization={setShowCreateNewOrganization}
            />
          </div>

          <div className="px-3 w-full">
            <ChangeUserProfile changeOrganization={changeOrganization} />
          </div>
        </div>
      </div>
    </Drawer>
  );
};

export default Sidebar;



export  function CreateOrganizationModal({
  open,
  onClose,
  user,
  setUser_,
  addOrganization,
  loader,
}) {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 360,
          bgcolor: "#fff",
          borderRadius: "8px",
          boxShadow: 24,
          p: 3,
        }}
      >
        {/* Header */}
        <div className="flex items-center justify-between mb-4">
          <div className="text-[13px] font-medium text-gray-800">
            Company name
          </div>

          <X
            className="w-4 h-4 text-gray-400 cursor-pointer"
            onClick={onClose}
          />
        </div>

        {/* Input */}
        <InputBase
          placeholder="Organization name"
          value={user.company_name||''}
          onChange={(e) => {
            setUser_({ ...user, company_name: e.target.value });
          }}
          sx={{
            bgcolor: "#F7F7F8",
            width: "100%",
            px: 2,
            py: "6px",
            fontSize: "14px",
            borderRadius: "4px",
            mb: 3,
          }}
        />

        {/* Action */}
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={addOrganization}
          disabled={loader}
          sx={{
            borderRadius: "4px",
            py: "6px",
            fontSize: "12px",
          }}
        >
          {loader ? (
            <CircularProgress size={20} thickness={4} sx={{ color: "#fff" }} />
          ) : (
            "Create New Organization"
          )}
        </Button>
      </Box>
    </Modal>
  );
}
